import { dayjs } from "@/core/utils/date";
import { FORMAT_SIMPLE_MONTH_DAY } from "@/core/utils/date";
import {
  IBusiness,
  IEnrichedBusiness,
  IBusinessWeeklyStatsItem,
} from "./business";
import {
  PAY_PERIOD_TEMPLATE_CADENCE,
  PAY_PERIOD_TEMPLATE_START_DAY_OF_WEEK,
} from "./constants";

export const getEnrichedBusiness = (
  business: IBusiness,
): IEnrichedBusiness => ({
  ...business,
  current_pay_period_template: business.current_pay_period_template || {
    cadence: PAY_PERIOD_TEMPLATE_CADENCE.weekly,
    start_day_of_week: PAY_PERIOD_TEMPLATE_START_DAY_OF_WEEK.monday,
  },
});

export const getEnrichedBusinessWeeklyStats = (
  stats: IBusinessWeeklyStatsItem[],
) =>
  stats.map((stat) => ({
    ...stat,
    week_range: `${dayjs(stat.week_start).format(FORMAT_SIMPLE_MONTH_DAY)} - ${dayjs(stat.week_end).format(FORMAT_SIMPLE_MONTH_DAY)}`,
  }));
